import React from 'react';

const MensajeError = (props) => {
    if (!props.error)
        return null;

    return (
        <div className="container-message-onscreen error bottom-separator-xs">
            <div className="zmdi">
                <div className="message">
                    <label className="word-break-word zmdi-alert-circle">
                        {props.error}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default MensajeError;


// WEBPACK FOOTER //
// ./Portico/App/Screens/CambioContrasena/components/MensajeError.js